import { PICKED_VIDEO_FILE } from "../actionTypes";

export const setVideoFile = (value) => {
  return {
    type: PICKED_VIDEO_FILE,
    payload: value,
  };
};
